module.exports = __webpack_public_path__ + "static/media/icon-info.1fba9b65.svg";